<template>
    <MaterialAlertWatchList></MaterialAlertWatchList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const MaterialAlertWatchList = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/WatchList/MaterialAlertWatchList.vue"
    )
);

export default {
    name: "WatchListTable", //The name you are in should not equal the name of the component you are importing.
    components: { MaterialAlertWatchList, AuthLayout },
};
</script>
